import { cn } from '@cobliteam/colib-ui/cn';
import Icon from '@cobliteam/ui/icons';
import { activeBarColor, iconColorClass } from '../helpers';
import type { Category, ColorKeys, TCounts } from '../types';

type ItemSidebarProps = {
  item: Category;
  active: boolean;
  onChangeCategory: (params: { categoryId: string; keepSearch: boolean }) => void;
  counts: TCounts;
};

const ItemSidebar = ({ item, active, onChangeCategory, counts }: ItemSidebarProps) => {
  return (
    <div
      tabIndex={-1}
      onClick={() => onChangeCategory({ categoryId: item.id, keepSearch: true })}
      key={item.id}
      className={cn(
        'relative flex h-9 w-full items-center justify-between gap-2 px-4 py-2 text-gray-11',
        'after:absolute after:inset-y-0 after:start-0 after:w-[2px]',
        'hover:bg-gray-4 hover:text-gray-12',
        active && 'bg-gray-3 text-gray-12 shadow-none',
        active && activeBarColor(item.color as ColorKeys)
      )}
    >
      <div className='flex items-center gap-2'>
        <Icon name={item.icon} className={cn(active && iconColorClass(item.color))} />
        <div className='w-full flex-1 text-left'>{item.name}</div>
      </div>
      <div className='flex w-[40px] items-center justify-end gap-2 text-right'>
        <div className='w-full text-right text-[10px] text-gray-11'>{counts[item.id as keyof TCounts]}</div>
      </div>
    </div>
  );
};

export default ItemSidebar;
